import { render, staticRenderFns } from "./Inspections.vue?vue&type=template&id=02ca898a&"
import script from "./Inspections.vue?vue&type=script&lang=js&"
export * from "./Inspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports